export const selectSelectedElements = (state) => state.selectedElements.selectedElements;
export const selectChangedElement = (state) => state.selectedElements.changedElement;
